<!-- partial:../../partials/_navbar.html -->
<!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
  <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
    style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
    <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
    <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
   
  </div>

</nav> -->
<!-- partial -->
<div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
  <!-- partial:../../partials/_sidebar.html -->

  <!-- partial -->
  <div class="main-panel">
    <div class="content-wrapper" style="padding: .5rem .8rem .5rem 3rem;">
      <div class="page-header">
        <h3 class="page-title text-primary">

          Output
        </h3>

      </div>

      <div class="row">
        <div class="col-md-2">
          <select class="txt-input" [(ngModel)]="AuditType">
            <option value="Post">Post</option>
            <option value="Pre">Checklist</option>
          </select>
        </div>
        <div class="col-md-2">
          <select class="txt-input" [(ngModel)]="Type">
            <option value="0" disabled>Search By</option>
            <option value="1">BE Date</option>
            <option value="2">Uploaded Date</option>
          </select>
        </div>
        <div class="col-md-2" style="padding-left: 10px; padding-right: 10px;">
          <input type="date" id="FromDate" [(ngModel)]="FromDate" class="txt-input" />
        </div>
        <div class="col-md-2" style="padding-left: 10px; padding-right: 10px;">
          <input type="date" id="ToDate" [(ngModel)]="ToDate" class="txt-input" />
        </div>
        <div class="col-md-4">
          <span *ngFor="let ip of InProgressBOE">{{ip.boeName}}&nbsp;</span>
        </div>
        <div class="col-md-12 stretch-card grid-margin">
          <div class="card">
            <div class="card-body" style="padding: 2rem 2.5rem 1.5rem 0rem;">
              <div class="clearfix">
                <div class="text-center" style="padding-top:10px; float: left;">
                  <div class="upload-btn-wrapper">
                    <button class="btnUpload" (click)="HeaderBtnClick()" id="btnHeader">Header</button>&nbsp;
                    <button class="btnUpload" (click)="InvoiceBtnClick()" id="btnInvoice">Invoice</button>&nbsp;
                    <button class="btnUpload" (click)="InvoiceItemBtnClick()" id="btnLineItem">Line Items</button>&nbsp;
                    <button class="btnUpload" (click)="ContainerBtnClick()" id="btnContainer">Container</button>&nbsp;
                    <button class="btnUpload" (click)="CertificateBondBtnClick()" id="btnCertBond">Certificate in Lieu
                      of Bond</button>&nbsp;
                    <button class="btnUpload" (click)="BondBtnClick()" id="btnBond">Bonds</button>&nbsp;
                    <button class="btnUpload" (click)="GstinBtnClick()" id="btnGSTs">GSTs</button>&nbsp;
                    <button class="btnUpload" (click)="LicenseBtnClick()" id="btnLicenses">Licenses</button>
                  </div>



                </div> <br />
                <div class="text-center" style="padding-top: 30px;">
                  <span [hidden]="isShownError" style="font-size:14px;color: red;">{{ErrorMsg}}</span>
                  <span [hidden]="isShownSuccess" style="font-size:14px;color: green;">{{SuccessMsg}}</span>
                </div>
              </div>

            </div>
          </div>
        </div>


      </div>

    </div>

    <div class="content-wrapper" [hidden]="ShownHeader">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5">

                        </div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterHeader($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button"></button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelHeader()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" #TABLE style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSource" #table style="width: 100%;" matSortmat-table
                          [dataSource]="dataSource" #table style="width: 100%;" matSort>
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;"> BE Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer;padding-left: 5px; padding-right: 5px;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.bedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="paymentMethod">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Method </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.paymentMethod}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="igmno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IGM Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.igmno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="pol">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Port of Loading </th>
                            <td mat-cell *matCellDef="let element"
                              style="min-width: 150px;cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.pol}} </td>
                          </ng-container>
                          <ng-container matColumnDef="coo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Country Of Origin </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.coo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="coc">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Country of Consignee </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.coc}} </td>
                          </ng-container>
                          <ng-container matColumnDef="blorMawb">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Master </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.blorMawb}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="hblorHawb">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> House </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.hblorHawb}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="shptType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Shipment Type </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.shptType}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="noOfPackages">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> No Of Packages </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.noOfPackages}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="packageUnit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Package Unit </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.packageUnit}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="grossWeight">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Gross Weight </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.grossWeight}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="grossWeightUnit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Gross Weight Units </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.grossWeightUnit}} </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]" showFirstLastButtons>
                        </mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper" [hidden]="ShownInvoice">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5"></div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterInvoice($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelInvoice()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceInv" style="width: 100%;" style="width: 100%;" matSort
                          #tableInvSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableInvPaginator.pageIndex * TableInvPaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.bedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invoiceNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invoiceDate}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="supplier">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Supplier </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;min-width: 250px;">
                              {{element.supplier}} </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Amount </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invoiceAmount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceCurrency">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Currency </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.invoiceCurrency}} </td>
                          </ng-container>
                          <ng-container matColumnDef="exchangeRate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Exchange Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.exchangeRate}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="toi">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Incoterm </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.toi}} </td>
                          </ng-container>
                          <ng-container matColumnDef="freightAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Freight Amount </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.freightAmount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="freightCurrency">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Freight Currency </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.freightCurrency}} </td>
                          </ng-container>
                          <ng-container matColumnDef="insurance">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Insurance </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.insurance}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="svbAss">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SVB Assessable Value </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.svbAss}} </td>
                          </ng-container>
                          <ng-container matColumnDef="svbDuty">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SVB Duty </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.svbDuty}} </td>
                          </ng-container>
                          <ng-container matColumnDef="hssRate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> HSS Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.hssRate}} </td>
                          </ng-container>

                          <ng-container matColumnDef="hssAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> HSS Amount </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.hssAmount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="discountRate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Discount Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.discountRate}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="discountAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Discount Amount </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.discountAmount}} </td>
                          </ng-container>
                          <ng-container matColumnDef="edd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> EDD </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.edd}} </td>
                          </ng-container>
                          <ng-container matColumnDef="xbeDutyFgInt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> XBE Duty </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.xbeDutyFgInt}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="isAffiliate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Is Affiliated? </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.isAffiliate}}
                            </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumnsInv"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsInv;"></tr>
                        </table>
                        <mat-paginator #TableInvPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper" [hidden]="ShownInvoiceContainer">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5"></div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterContainer($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelContainer()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceContainer" style="width: 100%;" style="width: 100%;"
                          matSort #tableContainerSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableContainerPaginator.pageIndex * TableContainerPaginator.pageSize) }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="boeno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.boeno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="boedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.boedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="slNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sequence </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.slNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="container">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Container Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.container}} </td>
                          </ng-container>
                          <ng-container matColumnDef="filledType">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> FCL/LCL </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.filledType}}
                            </td>
                          </ng-container>

                          <tr mat-header-row *matHeaderRowDef="displayedColumnsContainer"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsContainer;"></tr>
                        </table>
                        <mat-paginator #TableContainerPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper" [hidden]="ShownBonds">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5"></div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterBonds($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelBond()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceBonds" style="width: 100%;" style="width: 100%;"
                          matSort #TableBondsSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableBondsPaginator.pageIndex * TableBondsPaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bondNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bond Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bondNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bondAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bond Amount </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bondAmount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="bgrate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bank Guarantee Rate </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bgrate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bgamount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bank Guarantee Amount </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bgamount}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bondDebited">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bond Debited </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bondDebited}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="bgdebited">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Bank Guarantee Debited </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bgdebited}} </td>
                          </ng-container>


                          <tr mat-header-row *matHeaderRowDef="displayedColumnsBonds"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsBonds;"></tr>
                        </table>
                        <mat-paginator #TableBondsPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper" [hidden]="ShownGSTINs">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5"></div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterGstin($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelGstin()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceGstin" style="width: 100%;" style="width: 100%;"
                          matSort #TableGstinSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableGstinPaginator.pageIndex * TableGstinPaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="documentNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> GST Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.documentNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="type">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.type}} </td>
                          </ng-container>
                          <ng-container matColumnDef="stateCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> State Code </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.stateCode}} </td>
                          </ng-container>
                          <ng-container matColumnDef="state">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> State </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.state}} </td>
                          </ng-container>
                          <ng-container matColumnDef="igstassVal">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IGST Assessable Value </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.igstassVal}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="igstamount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IGST Amount </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.igstamount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="gstcessAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> GST CESS Amount </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.gstcessAmount}}
                            </td>
                          </ng-container>


                          <tr mat-header-row *matHeaderRowDef="displayedColumnsGstin"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsGstin;"></tr>
                        </table>
                        <mat-paginator #TableGstinPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper" [hidden]="ShownLicenses">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5"></div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterLicense($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelLicense()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceLicense" style="width: 100%;" style="width: 100%;"
                          matSort #TableLicenseSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableLicensePaginator.pageIndex * TableLicensePaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="invNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Seq (BOE) </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invoiceNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="itemNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Line Number (BOE) </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.itemNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="licenceNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Licence Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.licenceNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="itemNoInvoice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Line Number (Invoice) </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.itemNoInvoice}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="licenceDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Licence Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.licenceDate}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="regNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Registration Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.regNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="regDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Registration Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.regDate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="debitValue">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Value Debited </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.debitValue}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="qty">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Debit Quantity </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.qty}} </td>
                          </ng-container>
                          <ng-container matColumnDef="debitDuty">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Duty Debited </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.debitDuty}}
                            </td>
                          </ng-container>


                          <tr mat-header-row *matHeaderRowDef="displayedColumnsLicense"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsLicense;"></tr>
                        </table>
                        <mat-paginator #TableLicensePaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper" [hidden]="ShownCertificateBond">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5"></div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterCertBond($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelCertBonds()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceCertBond" style="width: 100%;" style="width: 100%;"
                          matSort #TableCertBondSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableCertBondPaginator.pageIndex * TableCertBondPaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.bedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cetno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Certificate Number </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.cetno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="date1">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.date1}} </td>
                          </ng-container>
                          <ng-container matColumnDef="type1">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
                            <td mat-cell *matCellDef="let element" style="cursor: pointer;"> {{element.type1}} </td>
                          </ng-container>



                          <tr mat-header-row *matHeaderRowDef="displayedColumnsCertBond"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsCertBond;"></tr>
                        </table>
                        <mat-paginator #TableCertBondPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper" [hidden]="ShownInvoiceItems">

      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5">
                          <h4>As Per BOE</h4>
                        </div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterInvItem($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelInvoiceItem()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceInvItem" style="width: 100%;" style="width: 100%;"
                          matSort #TableInvItemSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef>
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index">
                              {{(j +1)  + (TableInvItemPaginator.pageIndex * TableInvItemPaginator.pageSize) }} </td>
                          </ng-container>
                          <ng-container matColumnDef="beno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;"> BE Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.beno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bedate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BE Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.bedate}} </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invoiceNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Date </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.invoiceDate}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="ritc">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> HS Code </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.ritc}} </td>
                          </ng-container>
                          <ng-container matColumnDef="partNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Part Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;min-width: 150px;">
                              {{element.partNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Short Description </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; min-width: 170px;">
                              {{element.description}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="longDescription">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Long Description </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;min-width: 300px;">
                              {{element.longDescription}} </td>
                          </ng-container>

                          <ng-container matColumnDef="licenceUsed">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Licence Used </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.licenceUsed}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="quantity">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Quantity </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.quantity}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="unitPrice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit Price </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.unitPrice}}
                            </td>
                          </ng-container>
                          <!-- <ng-container matColumnDef="cth">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CTH </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cth}} </td>
                          </ng-container> -->
                          <ng-container matColumnDef="cnotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Customs Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cnotn}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cntonSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Customs Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cntonSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="cusDtyRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Customs Duty Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cusDtyRt}}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="bcdAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BCD Amount (INR) </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.bcdAmount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmNotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADD Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.antiDmNotn}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmNotnSlno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADD Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.antiDmNotnSlno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmUnitPrice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADD Unit Price </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.antiDmUnitPrice}} </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmAmount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADD Amount </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.antiDmAmount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmCurrencyCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADD Currency </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;">
                              {{element.antiDmCurrencyCode}} </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmQty">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADD Quantity </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.antiDmQty}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="enotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Exim Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.enotn}} </td>
                          </ng-container>
                          <ng-container matColumnDef="entonSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Exim Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.entonSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="bcd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BCD </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.bcd}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cvd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CVD </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cvd}} </td>
                          </ng-container>
                          <ng-container matColumnDef="bcdfg">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> BCD Fg </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.bcdfg}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cvdfg">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CVD Fg </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cvdfg}} </td>
                          </ng-container>
                          <ng-container matColumnDef="unit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.unit}} </td>
                          </ng-container>
                          <ng-container matColumnDef="assVal">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessable Value </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.assVal}} </td>
                          </ng-container>
                          <ng-container matColumnDef="excDtyRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Excise Duty Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.excDtyRt}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="cvdamount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CVD Amount (INR) </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cvdamount}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="spExcDtyRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sp Ex Duty Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.spExcDtyRt}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="spExDt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sp Ex Duty </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.spExDt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="hcvdrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> HCVD Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.hcvdrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="hcvd">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> HCVD </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.hcvd}} </td>
                          </ng-container>
                          <ng-container matColumnDef="eccrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ECC Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.eccrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="ecc">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ECC </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.ecc}} </td>
                          </ng-container>
                          <!-- <ng-container matColumnDef="antid">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> ANTID </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.antid}} </td>
                          </ng-container> -->
                          <ng-container matColumnDef="sheccrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SHECC Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.sheccrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="shecc">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SHECC </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.shecc}} </td>
                          </ng-container>

                          <ng-container matColumnDef="cecrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CEC Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cecrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cec">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CEC </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cec}} </td>
                          </ng-container>
                          <!-- <ng-container matColumnDef="shecrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SHEC Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.shecrt}} </td>
                          </ng-container> -->
                          <ng-container matColumnDef="cshecrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CSHEC Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cshecrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cshec">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CSHEC </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.cshec}} </td>
                          </ng-container>


                          <ng-container matColumnDef="swsrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SWS Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.swsrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="sws">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> SWS </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.sws}} </td>
                          </ng-container>
                          <ng-container matColumnDef="igstnotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IGST Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.igstnotn}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="igstnothSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IGST Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.igstnothSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="igstrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> IGST Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.igstrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="gstcnotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> GST CESS Notification</th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.gstcnotn}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="gstcnotnSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> GST CESS Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.gstcnotnSlNo}}
                            </td>
                          </ng-container>

                          <ng-container matColumnDef="gstcrt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> GSTC Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.gstcrt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="gstc">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> GSTC </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.gstc}} </td>
                          </ng-container>
                          <ng-container matColumnDef="pgAssVal">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessable Value </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.pgAssVal}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="pgDutyVal">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Duty Value </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;"> {{element.pgDutyVal}}
                            </td>
                          </ng-container>


                          <tr mat-header-row *matHeaderRowDef="displayedColumnsInvItem"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsInvItem;"></tr>
                        </table>
                        <mat-paginator #TableInvItemPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-lg-12 grid-margin">
          <div class="card">


            <div class="card-body" style="padding: 0rem 0rem;">
              <div class="row">

                <div class="col-12 grid-margin">
                  <div class="card">
                    <div class="card-body">
                      <div class="col-lg-12 form-inline"
                        style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                        <div class="col-lg-5">
                          <h4>Discrepancy</h4>
                        </div>

                        <div class="col-lg-7 " style="padding-right:0px;">
                          <div class="form-group" style="float: right;">
                            <div class="input-group">
                              <input type="text" class="form-control" placeholder="Search..." aria-label="Search..."
                                aria-describedby="basic-addon2" (keyup)="applyFilterInvItemDis($event.target.value)">
                              <div class="input-group-append">
                                <!-- <button class="btn btn-sm btn-gradient-danger" type="button">Search</button> -->
                              </div>
                            </div>
                            <button type="button" class="btn btn-sm ">
                              <img src="../../assets/ExportPDF.png" />

                            </button>
                            <button type="button" class="btn  btn-sm" (click)="exportexcelInvoiceItemDis()">
                              <img src="../../assets/ExportExcel.png" />
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="mat-elevation-z8" style="width: 100%; overflow: scroll;">
                        <table mat-table [dataSource]="dataSourceInvItemDis" style="width: 100%;" style="width: 100%;"
                          matSort #TableInvItemDisSort="matSort">
                          <ng-container matColumnDef="sno">
                            <th mat-header-cell *matHeaderCellDef
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;">
                              S.No </th>
                            <td mat-cell *matCellDef="let item; let j = index" style="border: 1px solid !important;">
                              {{(j +1)  + (TableInvItemDisPaginator.pageIndex * TableInvItemDisPaginator.pageSize) }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="bE_No">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> BE Number
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;">
                              {{element.bE_No}} </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Invoice
                              Number </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;border: 1px solid !important;">
                              {{element.invoiceNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="invoiceDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Invoice Date
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px;border: 1px solid !important;">
                              {{element.invoiceDate}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="partNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Part Number
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 150px; "
                              [style.background-color]="element.partNoColor"> {{element.partNo}} </td>
                          </ng-container>
                          <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Short
                              Description </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 170px;"
                              [style.background-color]="element.descriptionColor"> {{element.description}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="longDescription">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Long
                              Description </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;min-width: 300px;"
                              [style.background-color]="element.longDescriptionColor">
                              {{element.longDescription}} </td>
                          </ng-container>
                          <ng-container matColumnDef="unitPrice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Unit Price
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.unitPriceColor"> {{element.unitPrice}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="unit">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Unit </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.unitColor"> {{element.unit}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cnotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Customs
                              Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.cNotnColor"> {{element.cNotn}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cntonSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Customs
                              Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.cNotnSlNoColor"> {{element.cNtonSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="cusDtyRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Custom Duty
                              Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.cusDtyRtColor"> {{element.cusDtyRt}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmNotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                              Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid  !important"
                              [style.background-color]="element.antiDmNotnColor"> {{element.antiDmNotn}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmNotnSlno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                              Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid  !important;"
                              [style.background-color]="element.antiDmNotnSlNoColor">
                              {{element.antiDmNotnSlno}} </td>
                          </ng-container>
                          <ng-container matColumnDef="antiDmUnitPrice">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ADD
                              Notification Unit Price </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;;"
                              [style.background-color]="element.antiDmUnitPriceColor">
                              {{element.antiDmUnitPrice}} </td>
                          </ng-container>
                          <ng-container matColumnDef="enotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Exim
                              Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;;"
                              [style.background-color]="element.enotnColor"> {{element.enotn}} </td>
                          </ng-container>

                          <ng-container matColumnDef="entonSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Exim
                              Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.enotnSlNoColor"> {{element.entonSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="excDtyRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> Excise Duty
                              Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.excDtyRtColor"> {{element.excDtyRt}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="hcvdRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> HCVD Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.hcvdRtColor"> {{element.hcvdRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="eccRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> ECC Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.eccRtColor"> {{element.eccRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="sheccRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> SHECC Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.sheccRtColor"> {{element.sheccRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cecRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> CEC Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.cecRtColor"> {{element.cecRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="cshecRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> CSHEC Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.cshecRtColor"> {{element.cshecRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="swsRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> SWS Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.swsRtColor"> {{element.swsRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="igstNotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST
                              Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.igstNotnColor"> {{element.igstNotn}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="igstNothSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST
                              Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.igstNotnSlNoColor"> {{element.igstNothSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="igstRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> IGST Rate
                            </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.igstRtColor"> {{element.igstRt}} </td>
                          </ng-container>
                          <ng-container matColumnDef="gstcNotn">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                              Notification </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.gstcNotnColor"> {{element.gstcNotn}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="gstcNotnSlNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                              Notification Sl No </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.gstcNotnSlNoColor"> {{element.gstcNotnSlNo}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="gstcRt">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                              style="padding-left: 5px; padding-right: 5px;border: 1px solid !important;"> GSTC
                              Notification Rate </th>
                            <td mat-cell *matCellDef="let element"
                              style="cursor: pointer; padding-left: 5px; padding-right: 5px; border: 1px solid !important;"
                              [style.background-color]="element.gstcRtColor"> {{element.gstcRt}} </td>
                          </ng-container>



                          <tr mat-header-row *matHeaderRowDef="displayedColumnsInvItemDis"></tr>
                          <tr mat-row *matRowDef="let row; columns: displayedColumnsInvItemDis;"></tr>
                        </table>
                        <mat-paginator #TableInvItemDisPaginator="matPaginator" [pageSizeOptions]="[5, 10,15, 20,30,40]"
                          showFirstLastButtons></mat-paginator>



                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>


    </div>
    <div class="row">
      <table id="tblHeader" [hidden]="ShownHeaderExport">
        <tr>
          <th>BE Number </th>
          <th>BE Date</th>
          <th>Payment Method</th>
          <th>IGM Number</th>
          <th>IGM Date</th>
          <th>Port of Loading</th>
          <th>BL Date</th>
          <th>Country Of Origin</th>
          <th>Country of Consignee</th>
          <th>Master</th>
          <th>House</th>
          <th>Shipment Type</th>
          <th>No Of Packages</th>
          <th>Package Unit</th>
          <th>Gross Weight</th>
          <th>Gross Weight Unit</th>
        </tr>

        <tr *ngFor="let hr of HeaderExport">
          <td>{{hr.beNumber}} </td>
          <td>{{hr.beDate}}</td>
          <td>{{hr.paymentMethod}}</td>
          <td>{{hr.igmNumber}}</td>
          <td>{{hr.igmdAte}}</td>
          <td>{{hr.portOfLoading}}</td>
          <td>{{hr.blDate}}</td>
          <td>{{hr.countryOfOrigin}}</td>
          <td>{{hr.countryOfConsignee}}</td>
          <td>{{hr.master}}</td>
          <td>{{hr.house}}</td>
          <td>{{hr.shipmentType}}</td>
          <td>{{hr.noOfPackages}}</td>
          <td>{{hr.packageUnit}}</td>
          <td>{{hr.grossWeight}}</td>
          <td>{{hr.grossWeightUnit}}</td>
        </tr>
      </table>

      <table id="tblInvoice" [hidden]="ShownHeaderExport">
        <tr>
          <th>BE Number</th>
          <th>BE Date</th>
          <th>Invoice Number</th>
          <th>Invoice Date</th>
          <th>Supplier</th>
          <th>Invoice Amount</th>
          <th>Invoice Currency</th>
          <th>Exchange Rate</th>
          <th>Incoterm</th>
          <th>Freight Amount</th>
          <th>Freight Currency</th>
          <th>Insurance</th>
          <th>SVB Assessable Value</th>
          <th>SVB Duty</th>
          <th>HSS Rate</th>
          <th>HSS Amount</th>
          <th>Discount Rate</th>
          <th>Discount Amount</th>
          <th>EDD</th>
          <th>XBE Duty</th>
          <th>Is Affiliated?</th>
        </tr>
        <tr *ngFor="let ie of InvoiceExport">
          <td>{{ie.beNumber}}</td>
          <td>{{ie.beDate}}</td>
          <td>{{ie.invoiceNumber}}</td>
          <td>{{ie.invoiceDate}}</td>
          <td>{{ie.supplier}}</td>
          <td>{{ie.invoiceAmount}}</td>
          <td>{{ie.invoiceCurrency}}</td>
          <td>{{ie.exchangeRate}}</td>
          <td>{{ie.incoterm}}</td>
          <td>{{ie.freightAmount}}</td>
          <td>{{ie.freightCurrency}}</td>
          <td>{{ie.insurance}}</td>
          <td>{{ie.svbAssessableValue}}</td>
          <td>{{ie.svbDuty}}</td>
          <td>{{ie.hssRate}}</td>
          <td>{{ie.hssAmount}}</td>
          <td>{{ie.discountRate}}</td>
          <td>{{ie.discountAmount}}</td>
          <td>{{ie.edd}}</td>
          <td>{{ie.xbeDutyFgInt}}</td>
          <td>{{ie.isAffiliate}}</td>
        </tr>
      </table>

      <table id=tblContainer [hidden]="ShownHeaderExport">
        <tr>
          <th>BE Number</th>
          <th>BE Date</th>
          <th>Sequence</th>
          <th>Container Number</th>
          <th>FCL/LCL</th>
        </tr>
        <tr *ngFor="let ce of ContainerExport">
          <td>{{ce.beNumber}}</td>
          <td>{{ce.beDate}}</td>
          <td>{{ce.sequence}}</td>
          <td>{{ce.containerNumber}}</td>
          <td>{{ce.fclLCL}}</td>
        </tr>
      </table>

      <table id="tblCertBond" [hidden]="ShownHeaderExport">
        <tr>
          <th>BE Number</th>
          <th>BE Date</th>
          <th>Certificate Number</th>
          <th>Date</th>
          <th>Type</th>
        </tr>
        <tr *ngFor="let cbe of CertBondsExport">
          <td>{{cbe.beNumber}}</td>
          <td>{{cbe.beDate}}</td>
          <td>{{cbe.certificateNumber}}</td>
          <td>{{cbe.date}}</td>
          <td>{{cbe.type1}}</td>
        </tr>
      </table>

      <table id="tblGST" [hidden]="ShownHeaderExport">
        <tr>
          <th>BE Number</th>
          <th>BE Date</th>
          <th>GST Number</th>
          <th>Type</th>
          <th>State Code</th>
          <th>State</th>
          <th>IGST Assessable Value</th>
          <th>IGST Amount</th>
          <th>GST CESS Amount</th>
        </tr>
        <tr *ngFor="let ge of GSTExport">
          <td>{{ge.beNumber}}</td>
          <td>{{ge.beDate}}</td>
          <td>{{ge.gstNumber}}</td>
          <td>{{ge.type}}</td>
          <td>{{ge.stateCode}}</td>
          <td>{{ge.state}}</td>
          <td>{{ge.igstAssessableValue}}</td>
          <td>{{ge.igstamount}}</td>
          <td>{{ge.gstcessAmount}}</td>
        </tr>
      </table>

      <table id="tblLicense" [hidden]="ShownHeaderExport">
        <tr>
          <th>BE Number</th>
          <th>Invoice Number</th>
          <th>Invoice Seq (BOE)</th>
          <th>Line Number (BOE)</th>
          <th>Licence Number</th>
          <th>Line Number (Invoice)</th>
          <th>Licence Date</th>
          <th> Registration Number</th>
          <th>Registration Date</th>
          <th>Value Debited</th>
          <th>Debit Quantity</th>
          <th>Duty Debited</th>
        </tr>
        <tr *ngFor="let lex of LicenseExport">
          <td>{{lex.beNumber}}</td>
          <td>{{lex.invoiceNumber}}</td>
          <td>{{lex.invoiceSequence}}</td>
          <td>{{lex.itemNumber}}</td>
          <td>{{lex.licenceNumber}}</td>
          <td>{{lex.itemNoInvoice}}</td>
          <td>{{lex.licenceDate}}</td>
          <td>{{lex.registrationNumber}}</td>
          <td>{{lex.registrationDate}}</td>
          <td>{{lex.valueDebit}}</td>
          <td>{{lex.debitQty}}</td>
          <td>{{lex.debitDuty}}</td>
        </tr>
      </table>
    </div>
    <footer class="footer">
      <div class="d-sm-flex justify-content-center">
        <span class="d-block d-sm-inline-block">
          © 2020 All Rights Reserved
          <a href="https://www.sysmedacmicrosoft.com/#!/" target="_blank" style="color:black;">
            <img src="../../assets/Logo-V3.png" width="70" />
          </a>

        </span>

      </div>
    </footer>

  </div>

</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <img src="../../assets/ajaxpop-loader.gif">
  <!-- <p style="color: white">Please Wait. </p>   -->
</ngx-spinner>